import { ruleOfTypeWillApply } from './rule-of-type-will-apply';
import { RuleType } from './types';

export const requiresAssignmentWillApply = ruleOfTypeWillApply(RuleType.RequiresAssignment);

export default requiresAssignmentWillApply;
